import { DynamicIcon } from 'lucide-react/dynamic';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ShopItem } from '../../service/api';

interface ItemCardProps {
  item: ShopItem;
  quantity?: number;
  showPrice?: boolean;
  showTitle?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const ItemCard: React.FC<ItemCardProps> = ({
  item,
  quantity = 1,
  showPrice = false,
  showTitle = false,
  size = 'md',
  className = '',
}) => {
  const { t } = useTranslation();
  const sizeConfig = {
    sm: { container: '3rem', icon: 32 },
    md: { container: '4rem', icon: 48 },
    lg: { container: '5rem', icon: 64 },
  };

  const config = sizeConfig[size];

  return (
    <div className={`d-flex flex-column align-items-center ${className}`}>
      <div className="position-relative">
        <div
          className="d-flex align-items-center justify-content-center rounded-3 bg-primary"
          style={{
            width: config.container,
            height: config.container,
          }}
        >
          <DynamicIcon
            name={item.icon}
            size={config.icon}
            strokeWidth={1.5}
            className="text-white"
          />
        </div>
        {quantity > 0 && (
          <span
            className="position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger text-white"
            style={{ fontSize: '0.7rem', minWidth: '1.5rem' }}
          >
            x{quantity}
          </span>
        )}
      </div>
      <div className="mt-2 text-center">
        {showTitle && <div className="fw-bold text-white">{item.title}</div>}
        {showPrice && (
          <div className="small text-white-50">
            {item.price} {t('common.stickers')}
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemCard;
export type { ItemCardProps };
